import { attr } from '@ember-data/model';
import ShModel from './sh-model';

const VideoCategory = ShModel.extend({
  label: attr('string'),
  createdAt: attr('date'),
  updatedAt: attr('date'),
});

export default VideoCategory;
